"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = __importDefault(require("./axiosClient"));
async function handleAxiosClientRequest(queryOptions) {
    const response = await (0, axiosClient_1.default)()(queryOptions);
    return response.data;
}
exports.default = handleAxiosClientRequest;
//# sourceMappingURL=handleAxiosClientRequest.js.map